import React, { useEffect, useState } from "react";
import EventCard from "./eventCard.js";
import EditEvent from "./editEvent.js";
import "../css/individualEventCard.css";
import { BASE_URL } from "../constants";
import { useLanguage } from "../components/Language.js";

function IndividualEventCard({ eventId, onClose, user }) {
    const [event, setEvent] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const [isEditEventVisible, setIsEditEventVisible] = useState(false);
    const [eventToEdit, setEventToEdit] = useState(null);

    const {language} = useLanguage();

    const translations = {
        en: {
            loadingEventDetails: "Loading event details...",
            eventNotFound: "Event not found.",
            viewing: "Viewing"
        },
        gd: {
            loadingEventDetails: "Fiosrachadh luchdachaidh an tachartais ...",
            eventNotFound: "Cha do lorgadh an tachartas",
            viewing: ""
        },
    };

    const fetchEventData = async (eventId) => {
        try {
            const response = await fetch(`${BASE_URL}/api/gather_event_data/`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({ event_id: eventId }),
            });

            if (response.ok) {
                const data = await response.json();
                setEvent(data[0]);
            } else {
                console.error("Failed to fetch event details");
            }
        } catch (error) {
            console.error("Error fetching event details:", error);
        } finally {
            setIsLoading(false);
        }
    };

    const fetchEventToEdit = async (event_id) => {
        try {
            const response = await fetch(`${BASE_URL}/api/event_to_edit/`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({ event_id: event_id }),
            });

            if (response.ok) {
                const data = await response.json();
                setEventToEdit(data);
                setIsEditEventVisible(true);
            } else {
                console.error("Failed to fetch event for editing");
            }
        } catch (error) {
            console.error("Error fetching event for editing:", error);
        }
    };

    async function performEventDetailUpdate(event_id, field, newValue) { 
        
        console.log("event id ", event_id );
        console.log("field ", field );
        console.log("new value ", newValue );
    
        const response = await fetch(`${BASE_URL}/api/update_event/`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ event_id: event_id, field: field, newValue: newValue, set_confirm_title:false  }),
        });
    
        if (!response.ok){
          throw new Error('Unable to receive successful network response');
        }
        const data = await response.json();
        
        if (typeof data["error"] !== 'undefined'){
          console.log(data["error"]);
    
           if (window.confirm(data["error"] + "Do you want to continue?")){
    
              const response = await fetch(`${BASE_URL}/api/update_event/`, {
                method: "POST",
                headers: {
                  "Content-Type": "application/json",
                },
                body: JSON.stringify({ event_id: event_id, field: field, newValue: newValue, set_confirm_title:true }),
              });
    
              if (!response.ok){
                throw new Error('Unable to receive successful network response');
              }
    
            }else{
              return JSON.stringify({error: true })
            }
        }
    
        return JSON.stringify({error: false})
    
    };
    
    async function performLikeUpdate(event_id, username) { 
        try {
            const res = await fetch(`${BASE_URL}/api/update_likes/`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({ event_id: event_id, username: username }),
            });
    
            if (!res.ok) {
                throw new Error('Failed to update likes');
            }
    
            let response = await res.json();
            alert(response.message);
    
            setEvent((prevEvent) => ({
                ...prevEvent,
                number_likes: response.new_like_count,
            }));
    
            fetchEventData(event_id);
    
        } catch (error) {
            console.error("Error updating likes:", error);
        }
    };

    async function performCheckinUpdate(event_id, username) { 
        try {
            const res = await fetch(`${BASE_URL}/api/update_checkins/`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({ event_id: event_id, username: username }),
            });
    
            if (!res.ok) {
                throw new Error('Failed to check in to event');
            }
    
            let response = await res.json();
            alert(response.message);
    
            setEvent((prevEvent) => ({
                ...prevEvent,
                check_ins: response.new_checkin_count,
            }));
    
            fetchEventData(event_id);
    
        } catch (error) {
            console.error("Error checking into event:", error);
        }
    }; 

    const handleEdit = (event_id) => {
        fetchEventToEdit(event_id);
    };

    useEffect(() => {
        fetchEventData(eventId);
    }, [eventId]);

    return (
            <div className="individual-event-card">
                
                {isLoading ? (
                    <p>{translations[language].loadingEventDetails}</p>
                ) : event ? (
                    <>
                        <div className="mb-4">
                            <h2>{translations[language].viewing} {event.title}</h2>
                            <button className="close-x" onClick={onClose}>&times;</button>
                        </div>

                        {/* Show EventCard if not in edit mode */}
                        {!isEditEventVisible ? (
                            <EventCard
                                onclose={onClose}
                                event_id={event.id}
                                title={event.title}
                                description={event.description}
                                start_time={event.start_time}
                                end_time={event.end_time}
                                start_date={event.start_date}
                                end_date={event.end_date}
                                postcode={event.postcode}
                                latitude={event.latitude}
                                longitude={event.longitude}
                                event_picture={event.picture}
                                event_proficiency={event.proficiency}
                                type={event.type}
                                age_bracket={event.age_bracket}
                                language={event.language}
                                host_username={event.host_username}
                                host_name={event.host_name}
                                check_ins={event.check_ins}
                                number_likes={event.likes}
                                performCheckinUpdate={performCheckinUpdate}
                                performLikeUpdate={performLikeUpdate}
                                fetchEvents={() => {}}
                                handleEdit={handleEdit} // Pass handleEdit
                                user={user}
                                onDeleteSuccess={() => {}}
                            />
                        ) : (
                            // Show EditEvent component when in edit mode
                            <EditEvent
                                onclose={() => setIsEditEventVisible(false)}
                                event_id={eventToEdit.id}
                                title={eventToEdit.title}
                                description={eventToEdit.description}
                                start_time={eventToEdit.start_time}
                                end_time={eventToEdit.end_time}
                                start_date={eventToEdit.start_date}
                                end_date={eventToEdit.end_date}
                                postcode={eventToEdit.postcode}
                                latitude={eventToEdit.latitude}
                                longitude={eventToEdit.longitude}
                                event_picture={eventToEdit.picture}
                                event_proficiency={eventToEdit.proficiency}
                                type={eventToEdit.type}
                                age_bracket={eventToEdit.age_bracket}
                                language={eventToEdit.language}
                                host_username={eventToEdit.host_username}
                                host_name={eventToEdit.host_name}
                                performEventDetailUpdate={performEventDetailUpdate}
                            />
                        )}
                    </>
                ) : (
                    <p>{translations[language].eventNotFound}</p>
                )}
            </div>
    );
}

export default IndividualEventCard;
